import { gql } from 'apollo-boost';

export const SUBMIT_SEARCH_FILTER_SUGGESTION = gql`
    mutation($data: SubmitSearchFilterSuggestionInput!) {
        submitSearchFilterSuggestion(data: $data)
    }
`;
